import { render, staticRenderFns } from "./testimonial.vue?vue&type=template&id=16a67317"
import script from "./testimonial.vue?vue&type=script&lang=ts"
export * from "./testimonial.vue?vue&type=script&lang=ts"
import style0 from "./testimonial.vue?vue&type=style&index=0&id=16a67317&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports